import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';
import { blogPosts } from '../data/blog-posts';
import dalysWebsiteImage from '../assets/images/dalys-website.png';
import dossierWebsiteImage from '../assets/images/dossier-website.png';
import iotWebsiteImage from '../assets/images/iot-dashboard.png';
import { useTranslation } from 'react-i18next';


const projectImageMap = {
  "Dalys Case Study": dalysWebsiteImage,
  "Dossier AM Case Study": dossierWebsiteImage,
  "Full Stack IOT Platform Case Study": iotWebsiteImage
};


const featuredProjects = blogPosts.filter(post => post.type === 'Case Study')
                                 .sort(() => 0.5 - Math.random())
                                 .slice(0, 3);

const FeaturedProjects = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold font-heading text-gray-900">{t('featuredProjects.title')}</h2>
          <p className="text-lg text-gray-600 mt-2">
            {t('featuredProjects.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 h-[400px]">
          {featuredProjects.map((project, index) => {
            let spanClass = 'md:col-span-1 md:row-span-1';

            return (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.5 }}
              className={`group relative overflow-hidden rounded-xl shadow-sm border border-gray-100 cursor-pointer ${spanClass}`}
            >
              <Link to={`/blog/${project.slug}`}>
                <img src={projectImageMap[project.title]} alt={project.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6">
                  <h3 className="text-2xl font-bold text-white drop-shadow-md">{project.title}</h3>
                  <p className="text-gray-200 drop-shadow-md">{project.category}</p>
                </div>
              </Link>
            </motion.div>
            )
          })}
        </div>
        <div className="text-center mt-12">
            <Link to="/blog" className="inline-flex items-center gap-2 text-lg font-semibold text-[#0D2B45]">
                {t('featuredProjects.readMore')} <ArrowRight />
            </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProjects; 